// CategoryList.tsx
import React from "react";
import { Category } from "./types";
import "./CategoryList.css";

type Props = {
    categories: Category[];
    selectedCategory: string;
    onSelect: (id: string) => void;
};

const CategoryList: React.FC<Props> = ({ categories, selectedCategory, onSelect }) => {
    return (
        <div className="category-bar">
            {categories.map(cat => (
                <button
                    key={cat.id}
                    className={`category-pill${selectedCategory === cat.id ? " active" : ""}`}
                    onClick={() => onSelect(cat.id)}
                >
                    {cat.image && (
                        <img
                            src={cat.image}
                            alt=""
                            className="category-icon"
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            style={{
                                width: '24px',
                                height: '24px',
                                marginRight: '5px',
                                borderRadius: '50%',
                                objectFit: 'cover'
                            }}
                        />
                    )}
                    {cat.name}
                </button>
            ))}
        </div>
    );
};

export default CategoryList;
